import { getToken } from '../user/tokens'
import { getUser } from '../user/helpers'
import { userLanguageSelector } from '~/tools/localization'
import axios from 'axios'
import getCountryCode from '~/tools/userEnvironment/getCountryCode'

var cache = {}

export function getVideoInfo(videoId, cb) {
  if (cache[videoId])
    return cb(cache[videoId])

  getToken(token => {
    if (!token) {
      console.error('No user token')
      return
    }

    axios({
      method: 'GET',
      url: `${window.settings.apiBaseUrl}/user/info/video/${videoId}`,
      params: { site: window.settings.internalName },
      headers: {
        Authorization: token,
        'x-api-key': window.settings.baseAPIKey
      }
    }).then(res => {
      cache[videoId] = res.data
      cb(cache[videoId])
    }).catch(err => {
      console.error(err)
    })
  })
}

export function getVideoData(videoId, cb) {
  getToken(token => {
  const languageCode = window.userLanguageSelection || userLanguageSelector()
  axios
    .get(`${window.settings.apiBaseUrl}/content/videos/` + videoId, {
      params: {
        site: window.settings.internalName,
        ...(languageCode ? { languageCode } : {})
      },
      headers: {
        Authorization: token,
        'x-api-key': window.settings.baseAPIKey
      },
      contentType: 'application/json',
    }).then(res => {
      cache[videoId] = res.data
      cb(cache[videoId])
    }).catch(err => {
      console.error(err)
    })
  })
}

export function addToQueue(videoId, contentType, cb, cbCatch) {
  // console.log('adding', videoId)
  getUser(user => {
    getToken(token => {
      // console.log(user)
      axios({
        method: "POST",
        url: `${window.settings.apiBaseUrl}/user/queues`,
        params: { site: window.settings.internalName },
        headers: {
          Authorization: token,
          "x-api-key": window.settings.baseAPIKey
        },
        data: {
          userId: user.userId,
          contentId: videoId,
          position: 1,
          contentType: contentType
        }
      })
        .then(res => {
          // cache[videoId] = null
          if (cache[videoId]) cache[videoId].isQueued = true;

          getVideoInfo(videoId, cb);
        })
        .catch(err => {
          cbCatch();
          console.error(err);
        });
    })
  })
}

export function playVideo(userId, videoId) {
  getToken(token => {
    axios({
      method: 'PUT',
      url: `${window.settings.apiBaseUrl}/transaction/changeStatus`,
      params: { userId: userId, videoId: videoId },
      headers: {
        Authorization: token,
        'x-api-key': window.settings.baseAPIKey
      },
    }).catch(err => {
      console.error(err)
    })
  })
}

export function removeFromQueue(videoId, cb, cbCatch) {
  // console.log('removing', videoId)
  getUser(user => {
    getToken(token => {
      axios({
        method: 'DELETE',
        url: `${window.settings.apiBaseUrl}/user/queues`,
        params: { site: window.settings.internalName, userId: user.userId, 'contentIds': videoId },
        headers: {
          Authorization: token,
          'x-api-key': window.settings.baseAPIKey
        },
      }).then(res => {
        // cache[videoId] = null
        if (cache[videoId])
          cache[videoId].isQueued = false

        getVideoInfo(videoId, cb)
      }).catch(err => {
        cbCatch();
        console.error(err)
      })
    })
  })
}

export function deleteHistory(videoIds) {
  return getUser().then(user => {
    return getToken().then(token => {
      return axios({
        method: 'DELETE',
        url: `${window.settings.apiBaseUrl}/user/userId/history/video`,
        params: {
          version: "v2",
          ...(videoIds && { 'videoIds': videoIds }),
          site: window.settings.internalName
        },
        headers: {
          'Authorization': token,
          'x-api-key': window.settings.baseAPIKey
        }
      }).catch(err => console.log(err))
    })
  })
}

export function fetchSeriesHistory(userId, seriesId) {
  return getToken()
  .then(token => {
    return axios.get(`${window.settings.apiBaseUrl}/user/userId/history/video`, {
      headers: {
        Authorization: token,
        'x-api-key': window.settings.baseAPIKey,
      }, 
      params: {
        site: window.settings.internalName,
        version: "v2",
        seriesId: seriesId,
      }
    }).catch(err => console.log(err))
  })
}

export function fetchRecommendations(userId,requestType) {
  return getCountryCode().then(countryCode => {
    return getToken().then(token => {
      const languageCode = window.userLanguageSelection || userLanguageSelector()
      return axios({
        method: "GET",
        url:`${window.settings.apiBaseUrlCached || window.settings.apiBaseUrl}/user/recommendations/getRecommendations?userId=${userId}`,
        params: {
          site: window.settings.internalName,
          countryCode,
          languageCode,
          requestType
        },
        headers: {
          Authorization: token,
          "x-api-key": window.settings.baseAPIKey
        }
      })
      .then(x => {
        if(window.settings.recommendation && 
          window.settings.recommendation.recExcludedCountries && 
          window.settings.recommendation.recExcludedCountries.length>0 && 
          countryCode &&
          window.settings.recommendation.recExcludedCountries.includes(countryCode)){
            return [];
        }
        if(x.data)
          localStorage.setItem("recommendedVideoIds", JSON.stringify(x.data))
        return (x && x.data && x.data.records) || [];
      });
    })
  })
}

export function fetchHistory(userId, page) {
  return getToken().then(token => {
    return axios({
      method: "GET",
      url: `${window.settings.apiBaseUrl}/user/userId/history/video`,
      headers: {
        Authorization: token,
        "x-api-key": window.settings.baseAPIKey
      },
      params: {
        site: window.settings.internalName,
        version: "v2",
        limit: 25,
        ...(page && { 'page': page }),

      }
    }).then(x => (x && x.data && x.data.records) || []);
  })
}

export function getTransactionInfo(userId, contentMeta, ...options) {
  return getToken().then(token => {
    return axios({
      method: 'GET',
      url: `${window.settings.apiBaseUrl}/transaction/getData`,
      params: {
        site: window.settings.internalName,
        userId: userId,
        contentMeta: contentMeta,
        ...(options.length === 1 && { 'page': options[0], limit: 25 }),
        ...(options.length > 1 && { 'type': options[0], 'contentId': options[1] })
      },
      headers: {
        Authorization: token,
        'x-api-key': window.settings.baseAPIKey
      }
    }).catch(err => console.log(err))
  })
}

export function saveWatchHistory(data) {
  getToken().then(token => {
    axios({
      url: '/user/userId/history/video',
      baseURL: window.settings.apiBaseUrl,
      method: 'POST',
      headers: {
        'Authorization': token,
        'x-api-key': window.settings.baseAPIKey
      },
      params: {
        version: "v2"
      },
      data: JSON.stringify(data)
    })
  }).catch(error => { console.error(error) })
}

export function getLikedStatus(userId, contentId){
  return getToken().then(token => {
    return axios({
      url: '/user/likes',
      baseURL: window.settings.apiBaseUrl,
      method: 'GET',
      params:{
        userId: userId,
        site: window.settings.internalName,
        contentId: contentId
      },
      headers: {
        'Authorization': token
      }
    })
    .then(res =>{
      return res.data;
    })
  }).catch(err=>{console.log(err)})
}

export function getLikedCount(contentId){
  return getToken().then(token => {
    return axios({
      url: `/user/count/likes/${contentId}`,
      baseURL: window.settings.apiBaseUrl,
      method: 'GET',
      params: {
        site: window.settings.internalName
      },
      headers: {
        'Authorization': token,
        'x-api-key': window.settings.baseAPIKey
      }
    })
    .then(res => {
      return res.data;
    })
  })
  .catch(err=>{console.log(err)})
}

export function likeAVideo(userId, contentType, contentId, title){
  return getToken().then(token => {
    return axios({
      url: '/user/likes',
      baseURL: window.settings.apiBaseUrl,
      method: 'POST',
      params: {
        userId: userId,
        site: window.settings.internalName
      },
      data: {
        contentId: contentId,
        contentType: contentType,
        title: title
      },
      headers: {
        'Authorization': token
      }
    })
    .then(res => {
      return res.data;
    })
  })
  .catch(err=>{console.log(err)})
}

export function dislikeAVideo(userId, contentId){
  return getToken().then(token => {
    return axios({
      url: `/user/likes/${contentId}`,
      baseURL: window.settings.apiBaseUrl,
      method: 'DELETE',
      params: {
        userId: userId,
        site: window.settings.internalName
      },
      headers: {
        'Authorization': token
      }
    })
    .then(res => {
      return res.data;
    })
  })
  .catch(err=>{console.log(err)})
}